<template>
  <div class="add-project" :style="boxStyle">
    <a-form class="content__left--form" :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item 
        :label="type == 1 ? '页面标题' : '组件标题'" 
        prop="title"
        class="add-project-form-item">
        <a-input
          class="add-project-input"
          v-decorator="[
            'title',
            { rules: [{ required: true, message: type == 1 ? '请输入项目标题' : '请输入组件标题' }] },
          ]"
        />
      </a-form-item>
      <a-form-item 
        :label="type == 1 ? '页面编码' : '组件名称'"
        prop="name" 
        class="add-project-form-item">
        <a-input
          class="add-project-input"
          v-decorator="[
            'name',
            { 
              rules: [
                { 
                  required: true, 
                  message: type == 1 ? '请输入大写驼峰格式的页面编码,如：TestPage' : '请输入大写驼峰格式的组件名称,如：TestComponent',
                  pattern: /^[A-Z][a-zA-Z0-9]{1,}$/g
                }
              ] 
            },
          ]"
        />
      </a-form-item>

      

      <a-form-item label="页面描述" class="add-project-form-item">
        <a-input
          class="add-project-textarea"
          type="textarea"
          v-decorator="['description']"
        />
      </a-form-item>
      <!-- <a-form-item label="上传图片" class="add-project-form-item">
        <a-upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          list-type="picture"
          :default-file-list="fileList"
        >
          <a-button> <a-icon type="upload" /> 选择图片 </a-button>
        </a-upload>
      </a-form-item> -->


      <a-form-item
        label="标签"
        prop="delivery"
        class="add-project-form-item"
      >
        <SelectTags @getTags="handleChange" @tagFocus="getTagParams" :queryParams="tagParams" defaultSize="large"/>
      </a-form-item>
      <a-form-item
        v-if="type == 0" 
        label="缩略图上传"
        prop="file" 
        class="add-project-form-item">
        <a-upload
          name="file"
          :multiple="true"
        >
          <a-button> 
            <a-icon type="upload" />请选择图片
          </a-button>
        </a-upload>
      </a-form-item>
      <a-form-item
        label="项目权限"
        prop="projectPermissions"
        class="add-project-form-item radioGroup__style"
      >
        <PermissionsChoose @selectRido="getRidoVal"/>
        </a-form-item>
      <a-form-item >
        <p v-if="type == 1" class="form__tip">注意：请选择左侧模版，若不选择则为默认模版</p>
        <a-button type="primary" html-type="submit" @click="onSubmit" :style="type == 0 ? addStyle : {}">
          添 加
        </a-button>
      </a-form-item>
    </a-form>
    <div class="content__right--div" v-if="type == 1">
      <TemplateSearch :selectProjectId="selectProjectId" @search="search" @selectProject="selectProject"/>
      <TemplateCard :selectProjectId="selectProjectId" :selectPage="selectPage" @changeSelectPage="changeSelectPage" :selectKeyWord="selectKeyWord"/>
    </div>

  </div>
</template>
<script>
import componentApi from "@/request/api-manager/component.js";
import projectApi from "@/request/api-manager/project.js";
import SelectTags from './project/list/components/SelectTags'
import PermissionsChoose from '@/views/component/permissionsChoose/index'
import TemplateSearch from '@/views/pageComponent/TemplateSearch'
import TemplateCard from '@/views/pageComponent/TemplateCard'


export default {
  name: "add-project",
  components:{
    SelectTags,
    PermissionsChoose,
    TemplateSearch,
    TemplateCard,
  },
  data() {
    return {
      selectTag: [],
      size: "default",
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      chooseTag: [],
      tags: [],
      other: "",
      form: this.$form.createForm(this, "options"),
      fileList: [
      ],
      templateVisible:false,
      boxStyle:{},
      tagParams:{},
      selectProjectId: undefined,
      selectPage: {},
      selectKeyWord: undefined,

      type: 0,
      addStyle: {
        marginLeft: '80%'
      }
    };
  },
  mounted() {
    let self = this;
    self.tagList();
    self.type = self.$route.query.type
    // 计算高度
    this.$nextTick(()=>{
      window.onresize = ()=>{
        try {
          let num = document.body.clientHeight
          let layoutArr = document.getElementsByClassName('ant-layout')
          let headHeight = layoutArr[0].clientHeight
          let footerHeight = layoutArr[1].clientHeight
          this.boxStyle = {
            height:`${num - headHeight - footerHeight}px`
          }
        } catch (err){
          console.log(err)
        }
      }
    })
  },
  methods: {
    changeSelectPage(selectPage){
      console.log('selectPage', selectPage)
      this.selectPage = selectPage
    },
    selectProject(selectProjectId){
      console.log('selectProjectId', selectProjectId)
      this.selectProjectId = selectProjectId
    },
    tagList() {
      let self = this;
      let tagList = [];
      projectApi.tagList({ pageSize: 1000, pageNo: 1, type: 0 }).then((res) => {
        console.log("tag查询", res.result.records);
        res.result.records.forEach((element) => {
          element.disabled = true;
          tagList.push({ value: element.id, label: element.name });
        });
        self.tags = tagList;
      });
    },
    handleChange(value) {
      console.log(`Selected: ${value}`);
    },
    onSubmit() {
      let self = this;
      self.form.validateFields((err, values) => {
        if (!err) {
          let leftCurrent = self.type == 1 ? 2 : 1
          let component = self.form.getFieldsValue();
          component.projectId = self.$route.query.id
          component.type = self.type
          if ( self.type == 1 ) {
            component.templatePageId = this.selectPage.id
            component.templateProjectId = this.selectPage.projectId
          }
          console.log("12313123",component)
          componentApi.addComponent(component).then((res)=>{
            if (res.success) {
              self.$message.success('添加成功');
              self.$router.push({ path: "component/list", query: { projectId: self.$route.query.id,leftCurrent } })
            }else{
              self.$message.error(res.message);
            }
          })
        }
      });
    },
    resetForm() {},
    clickTag(tag) {
      if (tag.disabled) {
        if (this.chooseTag.length < 6) {
          tag.disabled = !tag.disabled;
          this.chooseTag.push(tag);
        } else {
          this.$message.info("最多选择6个标签");
        }
      } else {
        for (let index in this.chooseTag) {
          if (tag.id == this.chooseTag[index].id) {
            this.chooseTag.splice(index, 1);
            tag.disabled = !tag.disabled;
          }
        }
      }
      console.log(this.chooseTag);
    },
    getRidoVal(val){
      console.log(val)
    },
    getBuy(){
      console.log(2)
    },
    search(params){
      // console.log("搜索",params)
      this.selectKeyWord = params
    },
    /**
     * 获取请求的参数
     */
    getTagParams(){
      this.tagParams = {
        dataType:'page',
        params:{
          pageNo:1,
          pageSize:10,
          type:1
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-project {
  // width: 1400px;
  // margin: 0 auto;
  background-color: #f5f5f5;
  display: flex;
  .add-project-form-item {
    .add-project-input {
      width: 624px;
      height: 35px;
      line-height: 35px;
      // margin-top: 20px ;
    }
    .add-project-textarea {
      height: 177px;
    }
    .add-tag-block {
      .add-tag-item {
        display: inline-block;
        padding: 5px 10px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin: 5px;
      }
      .active {
        background-color: #fd4734;
        color: #fff;
        border-color: #fd4734;
      }
    }
    .tags__main--div{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .add-project-bottom {
    margin-top: 155px;
    .add-project-button {
      width: 87px;
      height: 43px;
      margin-left: 10px;
    }
  }
}

/deep/ .ant-form-item {
  display: flex;
  justify-content: center;
}
/deep/ .ant-form-item-control {
  width: 624px;
  line-height: 1.5vw;
}
/deep/ .add-tag-block {
  text-align: left;
}
/deep/ .ant-btn {
  // line-height: 2vw;
  font-weight: 500;
}
.content__left--form{
  flex: 1;
  margin-top: 50px;
  /deep/ .ant-form-item{
    margin:0;
    margin-top: 10px;
  }
}
.content__right--div{
  flex: 1;
  background: #fff;
  padding:0 20px;
  box-sizing: border-box;
  position: relative;
}
.form__tip{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0,0,0,0.45);
  line-height: 22px;
  margin-top: 20px;
}
</style>
